import { isMobile } from '../../utilities/user-agent';
import {resetPriceRange, resetDeliveryTime, resetSelectedFilter} from './pues';



export class SearchFilter {

  private rangeMinPrice: HTMLInputElement;
  private rangeMaxPrice: HTMLInputElement;
  private rangeBar: HTMLElement;
  private minPriceInputText: HTMLInputElement;
  private maxPriceInputText: HTMLInputElement;
  private priceFilterMsg: HTMLElement;
  private min: number;
  private max: number;
  private minPriceInputTextMin: string;
  private maxPriceInputTextMax: string;

  init() {

    const priceSlider = document.getElementById('price-range');
    if (!priceSlider) return;

    const min = priceSlider.querySelector<HTMLInputElement>('#minPrice');
    const max = priceSlider.querySelector<HTMLInputElement>('#maxPrice');
    const rangeBar = priceSlider.querySelector<HTMLElement>('.trackBar');

    const priceFilterMsg = document.querySelector<HTMLElement>('.price-filter-msg');
    const minText = document.getElementById('filter-slider-range.price-0') as HTMLInputElement | null;
    const maxText = document.getElementById('filter-slider-range.price-1') as HTMLInputElement | null;

    if (!min || !max || !rangeBar || !priceFilterMsg || !minText || !maxText) return;

    this.rangeMinPrice = min;
    this.rangeMaxPrice = max;
    this.rangeBar = rangeBar;
    this.priceFilterMsg = priceFilterMsg;
    this.minPriceInputText = minText;
    this.maxPriceInputText = maxText;

    this.min = parseInt(this.rangeMinPrice.min, 10);
    this.max = parseInt(this.rangeMaxPrice.max, 10);

    this.minPriceInputTextMin = this.minPriceInputText.min;
    this.maxPriceInputTextMax = this.maxPriceInputText.max;

    this.addRangeInputEvents();
    this.addTextInputEvents();
    this.updateRangeBar();
  }

  private addRangeInputEvents() {
    this.rangeMinPrice.addEventListener('input', () => this.changeMinRange());
    this.rangeMaxPrice.addEventListener('input', () => this.changeMaxRange());
    this.rangeMinPrice.addEventListener('change', () => this.changeMinRange());
    this.rangeMaxPrice.addEventListener('change', () => this.changeMaxRange());
  }

  private addTextInputEvents() {
    this.minPriceInputText.addEventListener('keyup', () => this.validateMinPriceKeyup());
    this.maxPriceInputText.addEventListener('keyup', () => this.validateMaxPriceKeyup());

    this.minPriceInputText.addEventListener('change', () => this.validatePriceChange());
    this.maxPriceInputText.addEventListener('change', () => this.validatePriceChange());
  }

  private changeMinRange() {
    let minVal = parseInt(this.rangeMinPrice.value);
    let maxVal = parseInt(this.rangeMaxPrice.value);

    if (maxVal <= minVal && maxVal < this.max) {
      maxVal = minVal + 1;
      this.rangeMaxPrice.value = maxVal.toString();
    }

    this.minPriceInputText.value = (minVal === this.max) ? (this.max - 1).toString() : minVal.toString();
    this.maxPriceInputText.value = maxVal.toString();

    this.hidePriceFilterMsg();
    this.updateRangeBar();
  }

  private changeMaxRange() {
    let minVal = parseInt(this.rangeMinPrice.value);
    let maxVal = parseInt(this.rangeMaxPrice.value);

    if (minVal >= maxVal && minVal > 0) {
      minVal = maxVal - 1;
      this.rangeMinPrice.value = minVal.toString();
    }

    this.maxPriceInputText.value = (maxVal === 0) ? '1' : maxVal.toString();
    this.minPriceInputText.value = minVal.toString();

    this.hidePriceFilterMsg();
    this.updateRangeBar();
  }

  private validateMinPriceKeyup() {
    const minText = this.minPriceInputText.value;
    const maxText = this.maxPriceInputText.value;

    if (minText && !maxText) {
      this.rangeMinPrice.value = minText;
      this.maxPriceInputText.value = this.maxPriceInputTextMax;
      this.rangeMaxPrice.value = this.maxPriceInputTextMax;
    }

    if (minText && maxText && parseInt(minText) < parseInt(maxText) && parseInt(minText) >= this.min) {
      this.rangeMinPrice.value = minText;
      this.hidePriceFilterMsg();
      this.updateRangeBar();
    } else {
      this.showPriceFilterMsg();
    }
  }

  private validateMaxPriceKeyup() {
    const maxText = this.maxPriceInputText.value;
    const minText = this.minPriceInputText.value;

    if (!minText && maxText) {
      this.rangeMaxPrice.value = maxText;
      this.minPriceInputText.value = this.minPriceInputTextMin;
      this.rangeMinPrice.value = this.minPriceInputTextMin;
    }

    if (maxText && minText && parseInt(maxText) > parseInt(minText) && parseInt(maxText) <= this.max) {
      this.rangeMaxPrice.value = maxText;
      this.hidePriceFilterMsg();
      this.updateRangeBar();
    } else {
      this.showPriceFilterMsg();
    }
  }

  private validatePriceChange() {
    const minVal = parseInt(this.minPriceInputText.value);
    const maxVal = parseInt(this.maxPriceInputText.value);

    if (
        this.minPriceInputText.value &&
        this.maxPriceInputText.value &&
        ((minVal >= maxVal && minVal < this.max) || (minVal <= maxVal && minVal > this.max) || (minVal < this.min) || (maxVal > this.max))
    ) {
      this.resetInputFields();
      this.hidePriceFilterMsg();
      this.updateRangeBar();
    }
  }

  private resetInputFields() {
    this.minPriceInputText.value = this.minPriceInputTextMin;
    this.maxPriceInputText.value = this.maxPriceInputTextMax;
    this.rangeMinPrice.value = this.minPriceInputTextMin;
    this.rangeMaxPrice.value = this.maxPriceInputTextMax;
  }

  private updateRangeBar() {
    const minVal = parseInt(this.rangeMinPrice.value);
    const maxVal = parseInt(this.rangeMaxPrice.value);
    const start = ((minVal - this.min) / (this.max - this.min)) * 100;
    const end = ((maxVal - this.min) / (this.max - this.min)) * 100;

    this.rangeBar.style.background = `linear-gradient(to right, #d6d6d6 ${start}%, #065066 ${start}%, #065066 ${end}%, #d6d6d6 ${end}%)`;
  }

  private showPriceFilterMsg() {
    this.priceFilterMsg.classList.remove('hidden');
  }

  private hidePriceFilterMsg() {
    if (!this.priceFilterMsg.classList.contains('hidden')) {
      this.priceFilterMsg.classList.add('hidden');
    }
  }

  activeFilter() {
    const activeFilters = document.querySelectorAll('.active-filter-container .filter-tag');
    const filterWrapper = document.querySelector('.filter-form-wrapper');

    activeFilters.forEach((filter: HTMLElement) => {
      filter.querySelector('.remove-tag').addEventListener('click', () => {
        if (filterWrapper) {
          filter.classList.add('loading');
          const filterValue = filter.dataset.value;
          if (filterValue === 'range.price') {
            resetPriceRange();
          } else if (filterValue === 'range.deliveryTime') {
            resetDeliveryTime();
          } else {
            const activeFilter = filterWrapper.querySelector(
                `.js-toggle-filter-check input[value="${filterValue}"][data-filter-id="${filter.dataset.id}"]`
            ) as HTMLInputElement;

            resetSelectedFilter(activeFilter);

            if (isMobile.any()) {
              const mobileFilterSubmit = document.querySelector('.mobile-filter-submit') as HTMLButtonElement;
              mobileFilterSubmit?.click();
            }
          }
        }
      });
    });
  }
}
